export default "__VITE_ASSET__DiLcby3a__"